export default __webpack_public_path__ + "f07af81f0d9d8087f8403ec3e19f5b1d.svg";